import { Control, useWatch } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router';
import { useDebounce } from 'react-use';

import { visitPaths } from '~libs.desktop.shared.paths';

import { formatDateToUrl, isToday } from '../../../AppointmentsFilterChips/DateChipFilter.utils';
import { FilterFormBean } from '../../AppointmentsFilterPanel';

import { DatePickerField } from './DatePickerField';

const DEBOUNCE_TIME_FOR_CHANGE_VALUE = 250;

export const useUpdateUrlFromDatePicker = (control: Control<FilterFormBean>, defaultDate: Date): void => {
   const history = useHistory();
   const location = useLocation();
   const day = useWatch<Date>({
      control: control,
      name: DatePickerField.fieldName,
      defaultValue: defaultDate,
   });

   useDebounce(
      () => {
         if (day) {
            const searchParams = new URLSearchParams(location.search);
            const newDate = isToday(day) ? visitPaths.APPOINTMENTS_DATE_TODAY_SEARCH_PARAM_VALUE : formatDateToUrl(day);
            searchParams.set(visitPaths.APPOINTMENTS_DATE_SEARCH_PARAM, newDate);
            history.replace({
               search: searchParams.toString(),
               state: location.state,
            });
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      },
      DEBOUNCE_TIME_FOR_CHANGE_VALUE,
      [day]
   );
};
